<ion-header class="m-operation-or-reject-reason-header">
  <ion-row class="m-operation-or-reject-reason-header__content ion-justify-content-between">
    <ion-col size="8" class="ion-no-padding">
      <div *ngIf="!isRecentDefectiveSelection">
        {{ 'operation_or_reject_reason_selection.defectiveHeading' | translate }}
      </div>
      <div *ngIf="isRecentDefectiveSelection">
        {{ 'operation_or_reject_reason_selection.recentDefectivesHeading' | translate }}
      </div>
    </ion-col>
    <ion-col size="4" class="ion-no-padding">
      <div class="m-operation-or-reject-reason-header__right-side-container">
        <div *ngIf="showShowingDefectsOption && !isRecentDefectiveSelection" class="show-sewing-defects">
          <ion-checkbox
            (ionChange)="showShowingDefectsChange()"
            [(ngModel)]="isShowShowingDefectsChecked"
            [checked]="isShowShowingDefectsChecked"
          ></ion-checkbox>
          <div class="text-container">Show Sewing Defects</div>
        </div>
        <div class="selected-count">
          {{ 'input_app_common.selected' | translate }}: {{ selectedOperationList.length }}
        </div>
      </div>
    </ion-col>
  </ion-row>
</ion-header>
<ion-content class="m-operation-or-reject-reason-content">
  <div class="m-operation-or-reject-reason-content__container">
    <div class="selected-bctx">
      <monorepo-bctx-header [bctxHeader]="bctxHeader" [background]="'rgba(238,238,239,.5)'"></monorepo-bctx-header>
    </div>
    <div *ngIf="deptWiseMultiSelectList" class="operation-reject-reason-list">
      <ion-row class="operation-reject-reason-list__heading ion-justify-content-between">
        <ion-col *ngIf="!isRecentDefectiveSelection" size="5" class="ion-no-padding">
          {{ 'operation_or_reject_reason_selection.selectOperations' | translate }}
        </ion-col>
        <ion-col *ngIf="isRecentDefectiveSelection" size="5" class="ion-no-padding">
          {{ 'operation_or_reject_reason_selection.operationsAndIssues' | translate }}
        </ion-col>
        <ion-col
          *ngIf="!isRecentDefectiveSelection && !isShowShowingDefectsChecked"
          size="5"
          class="ion-no-padding filter"
          (click)="onViewAllClick(departments[0])"
        >
          {{ 'input_app_common.viewAll' | translate }}
        </ion-col>
      </ion-row>
      <monorepo-multi-select
        *ngIf="!isShowShowingDefectsChecked"
        [type]="isRecentDefectiveSelection ? 'OPERATION_AND_DEFECT' : 'OPERATION_OR_DEFECT'"
        [lists]="
          isRecentDefectiveSelection ? recentDefectiveList : deptWiseMultiSelectList[departments[0]].operationList
        "
        [preSelectedList]="selectedOperationList"
        (selectedList)="handleOperationSelection($event, departments[0])"
        [enableSearch]="false"
      ></monorepo-multi-select>

      <div *ngIf="isShowShowingDefectsChecked">
        <div *ngFor="let department of departments" class="department-operations-selection-list__departments">
          <div class="department-dropdown" (click)="toggleDropdown(department)">
            <span>{{ department | titlecase }}</span>
            <ion-icon
              name="{{ deptWiseMultiSelectList[department].toggleHandler ? 'caret-up-outline' : 'caret-down-outline' }}"
            ></ion-icon>
          </div>
          <div class="department-operations-list" *ngIf="deptWiseMultiSelectList[department].toggleHandler">
            <div class="department-operations-list__viewAll" (click)="onViewAllClick(department)">
              {{ 'input_app_common.viewAll' | translate }}
            </div>
            <monorepo-multi-select
              [type]="'OPERATION_OR_DEFECT'"
              [lists]="deptWiseMultiSelectList[department].operationList"
              [preSelectedList]="deptWiseMultiSelectList[department].selectedOperationList"
              (selectedList)="handleOperationSelection($event, department)"
              [enableSearch]="false"
            ></monorepo-multi-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-row class="m-operation-or-reject-reason-footer ion-justify-content-between">
    <ion-col sizeLg="2" sizeMd="4" class="ion-no-padding">
      <ui-custom-button
        [buttonHeight]="'56px'"
        [buttonType]="'SECONDARY'"
        [btnTxt]="'input_app_common.clearAll' | translate"
        (clickEvent)="handleClearAll()"
      ></ui-custom-button
    ></ion-col>
    <ion-col sizeLg="4" sizeMd="6" class="ion-no-padding" style="text-align: end">
      <ui-custom-button
        [buttonHeight]="'56px'"
        [buttonType]="'SECONDARY'"
        [btnTxt]="'input_app_common.cancel' | translate"
        (clickEvent)="handleCancel()"
        style="margin-right: 16px"
      ></ui-custom-button>
      <ui-custom-button
        [buttonHeight]="'56px'"
        [btnTxt]="
          !isRecentDefectiveSelection ? ('input_app_common.next' | translate) : ('input_app_common.done' | translate)
        "
        (clickEvent)="handleNextOrDone()"
        [isDisabled]="!selectedOperationList.length"
      ></ui-custom-button>
    </ion-col>
  </ion-row>
</ion-footer>
